import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "grq_token";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=logged
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || null);

  const fetchMe = useCallback(async (tk) => {
    try {
      const res = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${tk}` },
      });
      setUser(res.data);
      return res.data;
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setToken(null);
      setUser(false);
      return null;
    }
  }, []);

  useEffect(() => {
    if (!token) {
      setUser(false);
      return;
    }
    fetchMe(token);
  }, [token, fetchMe]);

  const login = async (username, password) => {
    const res = await axios.post(`${API}/auth/login`, { username, password });
    const { access_token, ...rest } = res.data;
    localStorage.setItem(TOKEN_KEY, access_token);
    setToken(access_token);
    setUser(rest);
    return rest;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}

export function authHeader() {
  const tk = localStorage.getItem(TOKEN_KEY);
  return tk ? { Authorization: `Bearer ${tk}` } : {};
}
